var r = Array.isArray;
const a = r;
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isArray.js
// module id = 103
// module chunks = 67